export default __webpack_public_path__ + "static/Henkel-7f83c3794ef4a8ea943d15a999f6355f.png";